import { CHART_COLORS } from './chartColors';

/**
 * Transforms estadisLotes array to recharts PieChart format.
 * @param {Array<{DESCRIPCION: string, TOTAL: number}>} estadisLotes
 * @returns {Array<{name: string, value: number, fill: string}>}
 */
export function transformLotesData(estadisLotes) {
  if (!estadisLotes || !Array.isArray(estadisLotes) || estadisLotes.length === 0) {
    return [];
  }
  return estadisLotes.map((lote) => ({
    name: lote.DESCRIPCION,
    value: lote.TOTAL,
    fill: CHART_COLORS[lote.DESCRIPCION] || '#999999',
  }));
}

/**
 * Transforms estadisticas object to recharts BarChart format.
 * @param {{EFECTIVO: number, TARJETA: number, TRANSFERENCIA: number}} estadisticas
 * @returns {Array<{name: string, monto: number, fill: string}>}
 */
export function transformIngresosData(estadisticas) {
  if (!estadisticas || typeof estadisticas !== 'object' || Object.keys(estadisticas).length === 0) {
    return [];
  }
  return [
    { name: 'Efectivo', monto: estadisticas.EFECTIVO, fill: CHART_COLORS.EFECTIVO },
    { name: 'Tarjeta', monto: estadisticas.TARJETA, fill: CHART_COLORS.TARJETA },
    { name: 'Transferencia', monto: estadisticas.TRANSFERENCIA, fill: CHART_COLORS.TRANSFERENCIA },
  ];
}

/**
 * Transforms fechasM object to recharts AreaChart format.
 * @param {{[fecha: string]: number}} fechasM
 * @returns {Array<{fecha: string, monto: number}>}
 */
export function transformTendenciaData(fechasM) {
  if (!fechasM || typeof fechasM !== 'object' || Object.keys(fechasM).length === 0) {
    return [];
  }
  return Object.entries(fechasM).map(([fecha, monto]) => {
    // Convertir fecha a formato dd/mm/yy
    let fechaFormateada = fecha;
    try {
      const d = new Date(fecha);
      if (!isNaN(d)) {
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = String(d.getFullYear()).slice(-2);
        fechaFormateada = `${day}/${month}/${year}`;
      }
    } catch (e) { /* mantener fecha original */ }
    return { fecha: fechaFormateada, monto };
  });
}

/**
 * Transforms totalAmortizaciones to top 10 sorted desc by SUMATORIA_MONTOS.
 * @param {Array} totalAmortizaciones
 * @returns {Array<{nombre: string, monto: number, mensualidades: number, nombreCompleto: string}>}
 */
export function transformMoratoriosData(totalAmortizaciones) {
  if (!totalAmortizaciones || !Array.isArray(totalAmortizaciones) || totalAmortizaciones.length === 0) {
    return [];
  }
  return [...totalAmortizaciones]
    .sort((a, b) => parseFloat(b.SUMATORIA_MONTOS) - parseFloat(a.SUMATORIA_MONTOS))
    .slice(0, 10)
    .map((item) => ({
      nombre: `${item.NOMBRES} ${item.APELLIDO_PATERNO}`,
      monto: parseFloat(item.SUMATORIA_MONTOS),
      mensualidades: item.MENSUALIDADES_VENCIDAS,
      nombreCompleto: `${item.NOMBRES} ${item.APELLIDO_PATERNO} ${item.APELLIDO_MATERNO}`,
    }));
}

/**
 * Sums all montoapagar values from a projection array.
 * @param {Array<{montoapagar: number}>} proyeccionArray
 * @returns {number}
 */
export function sumProyeccion(proyeccionArray) {
  if (!proyeccionArray || !Array.isArray(proyeccionArray) || proyeccionArray.length === 0) {
    return 0;
  }
  return proyeccionArray.reduce((sum, item) => sum + (item.montoapagar || 0), 0);
}

/**
 * Formats a number with K/M suffix for abbreviated display.
 * @param {number} numero
 * @returns {string|number}
 */
export function formatAbreviado(numero) {
  if (numero >= 1000000) {
    return `${(numero / 1000000).toFixed(1)}M`;
  }
  if (numero >= 1000) {
    return `${(numero / 1000).toFixed(1)}K`;
  }
  return numero;
}
